// extracted by mini-css-extract-plugin
export default {"title":"Card_title__GsA-U","content":"Card_content__cA4fz"};